import React from 'react';
import styled from 'styled-components';
import { FormattedCurrency } from '@qover/react-intl';
import { BodyMixin } from '@qover/typography';
import { Price } from './summary.styles';

import CoverageIcon from './CoverageIcon';

const CartHeader = styled.div`
  ${BodyMixin};
  display: flex;
  padding-bottom: 14px;

  > div {
    display: flex;
    margin-right: auto;

    :last-child:not(:first-child) {
      max-width: 50%;
    }
  }
  svg {
    height: 20px;
    margin-right: 10px;
    margin-top: 3px;
    max-width: 20px;
    width: 100%;

    g {
      fill: ${({ theme }) => theme.colors.textQuote()};
      fill-opacity: 1;
    }
  }
`;

type SummaryProductTitleProps = {
  paymentRythmMessage: React.ReactNode;
  productPrice?: number;
  renderIcon?: React.FC;
  title: React.ReactNode;
};

export function SummaryProductTitle(props: SummaryProductTitleProps) {
  const RenderIcon = props.renderIcon ?? CoverageIcon;
  return (
    <CartHeader>
      <div>
        <RenderIcon />
        <span className="bold">{props.title}</span>
      </div>
      {!!props.productPrice && (
        <Price data-test="general.summaryCard.price">
          <FormattedCurrency value={props.productPrice} />{' '}
          {props.paymentRythmMessage}
        </Price>
      )}
    </CartHeader>
  );
}
